import { Marker, Popup  } from 'react-leaflet';

import useZoomLevel from '../../Optics/Markers/useZoomLevel';
import { iconPassiveNode, iconPassiveNodeKtv } from '../../Optics/Constants/ConstantsOptics';


const MarkersAmplifierPassiveNode = ({ data}) => {

  console.log(data);
  const zoomLevel = useZoomLevel();

   return (
    <>
      {data.map((item, index) => {
        if (zoomLevel <= 15) return null;

        const icon =
          item.ktvAmplifierId === null
            ? iconPassiveNode
            : iconPassiveNodeKtv;

        return (
          <Marker
            key={index}
            position={[item.latitude, item.longitude]}
            icon={icon}
          >
            <Popup className='custom-popupMap2'>
               <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <span style={{ color: '#e7e7e7', fontWeight: 'bold', fontSize: '16px' }}>Пассивный узел</span>
                            {item.ktvAmplifierId !== null && (
                                <div style={{ marginTop: 5, color: '#115711',fontWeight: 'bold', fontSize: '14px'}}>
                                  Есть усилитель
                                </div>
                              )}
                             
                              <div>
                                <hr className='horizontalLineFilter' />
                                <span style={{ color: '#3b3b3b', fontWeight: 'bold', fontSize: '14px' }}>{item.street}, дом. {item.numberHouse}</span>
                                <br />
                                <hr className='horizontalLineFilter' />
                               
                                <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                                  Подъезд:<span style={{ color: '#353535', fontWeight: 'normal' }}> {item.entrance}</span>
                                </span><br />

                                <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                                  Описание:<span style={{ color: '#353535', fontWeight: 'normal' }}> {item.description}</span>
                                </span><br />
                              
                               
                               
                              </div>
                            </div>
            </Popup>
          </Marker>
        );
      })}
       
    </>
  );
}

export default MarkersAmplifierPassiveNode;


